import ApiService from '../../../shared/services/ApiService';

export default {

    getMembers() {
        return ApiService.get('members');
    },

    getMembersWithSettings() {
        return ApiService.get('members-with-settings');
    },

    deleteInvite(inviteId) {
        return ApiService.delete(`delete-invite?invite_id=${inviteId}`);
    },

    deleteMember(memberId) {
        return ApiService.delete(`delete-member?user_id=${memberId}`);
    },

    updateMembesAndInvites(data) {
        return ApiService.post('update-members-and-invites', data);
    },

    updateMemberSettings(data) {
        return ApiService.post('update-member-settings', data);
    },

    changeMemberRole(data) {
        return ApiService.post('assign-role', data);
    },

    addMemberToDepartment(data) {
        return ApiService.post('add-member-in-department', data);
    },

    deleteMemberFromDepartment(data) {
        return ApiService.post('delete-member-from-department', data);
    },

    getArchivedMembers() {
        return ApiService.get('archived-members');
    }
}